import React, { FC } from 'react';
import { Image } from 'components/Image/Image';
import bank from 'images/icons/bank-payment.svg';
import verticalLine from 'images/icons/line-separator.svg';
import visa from 'images/icons/visa-logo.svg';
import amex from 'images/icons/amex-logo.svg';
import mastercard from 'images/icons/mastercard-logo.svg';
import discover from 'images/icons/discover-logo.svg';
import styles from './CreditCardIcons.module.scss';
import { useFeatureFlagsContext } from 'components/FeatureFlags/FeatureFlags';
import { usePaymentsToggle } from 'components/Cart/OrderSummary/PaymentsToggle/usePaymentsToggle/usePaymentsToggle';

export const CreditCardIcons: FC = () => {
  const { isPayMonthly } = usePaymentsToggle();

  const { isFlagEnabled } = useFeatureFlagsContext();
  const payWithCreditCardIsEnabled = isFlagEnabled('pay-with-credit-card-boarding');

  if (!payWithCreditCardIsEnabled || isPayMonthly) {
    return null;
  }

  return (
    <div className={styles.icons}>
      <Image src={bank} className={styles.iconsRightMargin} />
      <Image src={verticalLine} className={styles.iconsRightMargin} />
      <Image src={visa} className={styles.iconsCcRightMargin} />
      <Image src={amex} className={styles.iconsCcRightMargin} />
      <Image src={mastercard} className={styles.iconsCcRightMargin} />
      <Image src={discover} />
    </div>
  );
};
